export const exportFormats = ["csv", "xlsx", "json"];
export const exportFormatPng = "png";

export function accountSettings() {
  return "/account/profile";
}
